 export default {
   name: 'hero',
   components: {},
   props: {
     title: String,
     subtitle: String
   },
   data() {
     return {}
   },
   computed: {
     showTitle: function () {
       return (this.$route.path == "/")
     }
   },
   mounted() {},
   methods: {
     contact: function () {
       this.$store.commit("SET_CONTACTMODAL", true);
     }
   }
 }